function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#E2E2E2;}\n\t.st1{fill:#2FB9DA;}\n\t.st2{enable-background:new    ;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-278 -342)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-22.289 -7)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(300.289 349)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15,0.5h49C72,0.5,78.5,7,78.5,15l0,0c0,8-6.5,14.5-14.5,14.5H15C7,29.5,0.5,23,0.5,15l0,0 C0.5,7,7,0.5,15,0.5z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M368.9,362.5l-5.2-4.5c-0.3-0.3-0.8-0.2-1,0.1c-0.1,0.1-0.2,0.3-0.2,0.5v2.4c-4.8,0.1-8.6,1-8.6,5.5 c0.1,1.8,1,3.5,2.5,4.6c0.2,0.2,0.6,0.1,0.7-0.1c0.1-0.1,0.1-0.3,0.1-0.5c-1.4-4.3,0.6-5.5,5.3-5.5v2.6c0,0.4,0.3,0.7,0.7,0.7 c0.2,0,0.3-0.1,0.5-0.2l5.2-4.5C369.2,363.3,369.2,362.9,368.9,362.5C369,362.5,368.9,362.5,368.9,362.5z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M289.5,359c0,0,0.9,1,2.1,1c0.8,0,1.5-0.5,1.5-1.3c0-1.8-4.1-1.5-4.1-4.1c0-1.3,1.1-2.3,2.7-2.3 c0.9,0,2.4,0.4,2.4,1.6v0.7H293v-0.4c0-0.4-0.6-0.8-1.3-0.8c-0.9,0-1.5,0.5-1.5,1.1c0,1.7,4.1,1.3,4.1,4.1c0,1.3-1,2.4-2.7,2.4 c-1.8,0-2.8-1.3-2.8-1.3L289.5,359z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M296,353.8c0-0.2-0.1-0.3-0.3-0.3h-0.5v-1h1.2c0.5,0,0.8,0.2,0.8,0.8v3h4.3v-3c0-0.5,0.2-0.8,0.8-0.8h1.2v1 h-0.5c-0.2,0-0.3,0.1-0.3,0.3v7.2h-1.2v-3.7h-4.3v3.7H296V353.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M304.1,360h0.2c0.2,0,0.3,0,0.4-0.3l2.7-7.2h1.3l2.7,7.2c0.1,0.2,0.2,0.3,0.4,0.3h0.2v1h-0.7 c-0.6,0-0.8-0.1-1-0.7l-0.6-1.7h-3.1l-0.6,1.7c-0.2,0.6-0.4,0.7-1,0.7h-0.7V360z M309.2,357.6l-0.9-2.6c-0.2-0.4-0.3-1.2-0.3-1.2 h0c0,0-0.2,0.7-0.3,1.2l-0.9,2.6H309.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M313.1,353.6h-0.8v-1h3.7c1.5,0,2.5,0.9,2.5,2.5c0,1.4-0.9,2.1-1.5,2.2v0c0,0,0.2,0.1,0.4,0.4l1,2 c0.1,0.3,0.3,0.3,0.6,0.3h0.2v1h-0.6c-0.7,0-0.9-0.1-1.2-0.6l-1.2-2.3c-0.2-0.4-0.4-0.5-0.8-0.5h-1.1v3.4h-1.2V353.6z  M315.9,356.6c0.9,0,1.5-0.6,1.5-1.5s-0.5-1.5-1.4-1.5h-1.6v3H315.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M320.6,353.6h-0.8v-1h5c0.5,0,0.8,0.2,0.8,0.8v1.1h-1.1v-0.5c0-0.2-0.1-0.3-0.3-0.3h-2.4v2.7h3v1h-3v2.5 c0,0.2,0.1,0.3,0.3,0.3h2.5c0.2,0,0.3-0.1,0.3-0.3v-0.5h1.1v1.1c0,0.5-0.2,0.8-0.8,0.8h-3.8c-0.5,0-0.8-0.2-0.8-0.8V353.6z"
})));

var SvgShareCtaIcon = function SvgShareCtaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 30",
    style: {
      enableBackground: "new 0 0 79 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareCtaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShareCTA-icon.158b79b3.svg";
export { ForwardRef as ReactComponent };